import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth, useMain } from '../../hooks'
import d from '../../styles/Dashboard.module.css'
import o from '../../styles/Onboarding.module.css'
import s from '../../styles/Shared.module.css'
import { cf } from '../../utils'

const Step = ({ stepInfo }) => {
	const { currentStep } = useMain()
	const { uncompleted, userDetails } = useAuth()
	const location = useLocation()
	return (
		<Link
			to={
				uncompleted[stepInfo.step]
					? location.pathname
					: String(stepInfo.tag).toLowerCase()
			}
			className={cf(s.flex, s.flexCenter, o.stepCon)}
		>
			<>
				{stepInfo.step !== 2 ? (
					<div
						className={cf(s.flex, s.flexCenter, s.wMax, d.oStatusIconConInner)}
					>
						{uncompleted[stepInfo.step] ? (
							<div className={cf(o.stepMarkCon, d.stepMarkCon)}>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									className={cf(o.stepMark, d.stepMark)}
								>
									<path
										d='M4 13L9 18L20 7'
										stroke='white'
										strokeLinecap='round'
									/>
								</svg>
							</div>
						) : (
							<div
								className={cf(
									s.flex,
									s.flexCenter,
									o.step,
									currentStep === stepInfo.step ? o.currentStep : ''
								)}
							>
								{stepInfo.step}
							</div>
						)}
					</div>
				) : (
					<div
						className={cf(s.flex, s.flexCenter, s.wMax, d.oStatusIconConInner)}
					>
						{uncompleted[stepInfo.step] ? (
							<>
								{userDetails.kyc && userDetails.kyc.status ? (
									<>
										{userDetails.kyc.status === 'approved' ? (
											<div className={cf(o.stepMarkCon, d.stepMarkCon)}>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='24'
													height='24'
													viewBox='0 0 24 24'
													fill='none'
													className={cf(o.stepMark, d.stepMark)}
												>
													<path
														d='M4 13L9 18L20 7'
														stroke='white'
														strokeLinecap='round'
													/>
												</svg>
											</div>
										) : userDetails.kyc.status === 'completed' ? (
											<div className={cf(o.stepMarkCon, d.stepMarkCon)}>
												{stepInfo.step}
											</div>
										) : userDetails.kyc.status === 'rejected' ? (
											<div className={cf(o.stepMarkCon, d.stepMarkConRejected)}>
												<svg
													width='20'
													height='20'
													viewBox='0 0 20 20'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'
													className={cf(o.stepMark, d.stepMark)}
												>
													<g id='alert-triangle'>
														<path
															id='Icon'
															fillRule='evenodd'
															clipRule='evenodd'
															d='M12.641 4.40352C11.0941 3.17669 8.90608 3.17669 7.35919 4.40352C7.07322 4.63032 6.76025 5.00751 6.32754 5.68676C5.89736 6.36204 5.38792 7.27117 4.68819 8.5207C4.01536 9.72217 3.52655 10.5956 3.18842 11.2888C2.84879 11.9852 2.69462 12.4349 2.64878 12.7913C2.40193 14.7104 3.48251 16.554 5.27753 17.2763C5.61086 17.4104 6.07861 17.4956 6.85208 17.5395C7.62214 17.5832 8.62306 17.5835 10.0001 17.5835C11.3771 17.5835 12.3781 17.5832 13.1481 17.5395C13.9216 17.4956 14.3893 17.4104 14.7227 17.2763C16.5177 16.554 17.5983 14.7104 17.3514 12.7913C17.3056 12.4349 17.1514 11.9852 16.8118 11.2888C16.4736 10.5956 15.9848 9.72217 15.312 8.5207C14.6123 7.27117 14.1028 6.36204 13.6727 5.68676C13.24 5.00751 12.927 4.63032 12.641 4.40352ZM6.42711 3.22826C8.51995 1.56844 11.4802 1.56844 13.5731 3.22826C14.0604 3.61478 14.4818 4.16509 14.9378 4.88084C15.3935 5.59631 15.9235 6.54269 16.6085 7.76592L16.6086 7.76597L16.6208 7.78779L16.6329 7.80938L16.6329 7.80948C17.2911 8.98486 17.8009 9.89524 18.16 10.6313C18.5197 11.3687 18.7615 11.996 18.8392 12.5999C19.1731 15.1963 17.7112 17.6906 15.2826 18.6678C14.7177 18.8951 14.0523 18.9906 13.2331 19.0371C12.4155 19.0835 11.372 19.0835 10.0249 19.0835H10.0248H10.0248H10.0001H9.97541H9.97537H9.97533C8.62816 19.0835 7.58472 19.0835 6.76711 19.0371C5.94793 18.9906 5.2825 18.8951 4.71758 18.6678C2.28902 17.6906 0.827068 15.1963 1.16104 12.5999C1.23872 11.996 1.48054 11.3687 1.84025 10.6313C2.19926 9.89523 2.70908 8.98483 3.36731 7.80944L3.36734 7.80938L3.37943 7.78779L3.39163 7.766C4.07666 6.54273 4.60664 5.59633 5.06243 4.88084C5.5184 4.16509 5.93975 3.61478 6.42711 3.22826ZM10.0001 6.75015C10.4143 6.75015 10.7501 7.08594 10.7501 7.50015V10.8335C10.7501 11.2477 10.4143 11.5835 10.0001 11.5835C9.58589 11.5835 9.2501 11.2477 9.2501 10.8335V7.50015C9.2501 7.08594 9.58589 6.75015 10.0001 6.75015ZM10.0001 14.1668C10.4603 14.1668 10.8334 13.7937 10.8334 13.3335C10.8334 12.8732 10.4603 12.5001 10.0001 12.5001C9.53986 12.5001 9.16677 12.8732 9.16677 13.3335C9.16677 13.7937 9.53986 14.1668 10.0001 14.1668Z'
															fill='white'
														/>
													</g>
												</svg>
											</div>
										) : userDetails.kyc.status === 'pending' ? (
											<>
												{uncompleted[stepInfo.step] ? (
													<div className={cf(o.stepMarkCon, d.stepMarkCon)}>
														{stepInfo.step}
													</div>
												) : (
													<div
														className={cf(
															s.flex,
															s.flexCenter,
															o.step,
															currentStep === stepInfo.step ? o.currentStep : ''
														)}
													>
														{stepInfo.step}
													</div>
												)}
											</>
										) : (
											<div
												className={cf(
													s.flex,
													s.flexCenter,
													o.step,
													currentStep === stepInfo.step ? o.currentStep : ''
												)}
											>
												{stepInfo.step}
											</div>
										)}
									</>
								) : (
									<div
										className={cf(
											s.flex,
											s.flexCenter,
											o.step,
											currentStep === stepInfo.step ? o.currentStep : ''
										)}
									>
										{stepInfo.step}
									</div>
								)}
							</>
						) : (
							<div
								className={cf(
									s.flex,
									s.flexCenter,
									o.step,
									currentStep === stepInfo.step ? o.currentStep : ''
								)}
							>
								{stepInfo.step}
							</div>
						)}
					</div>
				)}
			</>
			<span
				className={cf(
					s.flex,
					s.flexCenter,
					o.tag,
					currentStep === stepInfo.step ? o.currentTag : ''
				)}
			>
				{stepInfo.tag}
			</span>
		</Link>
	)
}

export default Step
